import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCardLikeActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "url(#paint0_linear_706_106322)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 30L19.6471 29.7054C12.0588 23.5185 10 21.3384 10 17.803C10 14.8569 12.3529 12.5 15.2941 12.5C17.7059 12.5 19.0588 13.8552 20 14.9158C20.9412 13.8552 22.2941 12.5 24.7059 12.5C27.6471 12.5 30 14.8569 30 17.803C30 21.3384 27.9412 23.5185 20.3529 29.7054L20 30Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_706_106322",
			x1: 20,
			y1: 0,
			x2: 20,
			y2: 40,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF699C" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FE5763"
			})]
		}) })
	]
});
export default SvgCardLikeActive;
